import { render, staticRenderFns } from "./PreferencesModal.vue?vue&type=template&id=2b8946e7"
import script from "./PreferencesModal.vue?vue&type=script&lang=js"
export * from "./PreferencesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports